module.exports = __webpack_public_path__ + "media/images/riders/GREG_WILLIAMSON-06664870da04ba6f578ab96ee2414c51.png";